import { useTheme } from "@mui/material";
import { CarPdfBox, CarPdfBoxProps } from "@app/components/PdfBox";
import { CarPdfTypography } from "@app/components/PdfTypography";
import { Rect, Svg } from "@react-pdf/renderer";

interface SimulatedForwardProbabilitiesPdfChartLegendProps
  extends Omit<CarPdfBoxProps, "children"> {}

export const SimulatedForwardProbabilitiesPdfChartLegend = ({
  ...props
}: SimulatedForwardProbabilitiesPdfChartLegendProps) => {
  const theme = useTheme();

  const getItem = (label: string, color: string) => (
    <CarPdfBox
      style={{
        flexDirection: "row",
        gap: 6,
        alignItems: "center",
        minWidth: 70,
      }}
    >
      <Svg
        width={10}
        height={10}
        viewBox={"0 0 10 10"}
        style={{ width: 10, height: 10 }}
      >
        <Rect
          x={0}
          y={0}
          width={10}
          height={10}
          rx={4}
          ry={4}
          fill={theme.palette.gray6}
        />
        <Rect x={1} y={1} width={8} height={8} rx={3} ry={3} fill={color} />
      </Svg>
      <CarPdfTypography variant="v9Regular">{label}</CarPdfTypography>
    </CarPdfBox>
  );

  return (
    <CarPdfBox
      {...props}
      style={{
        ...props.style,
        width: 220,
        gap: 6,
      }}
    >
      <CarPdfBox style={{ flexDirection: "row", gap: 10 }}>
        <CarPdfTypography variant="v9Semibold" style={{ minWidth: 70 }}>
          Percentile:
        </CarPdfTypography>
        {getItem("95th - 75th", theme.palette.gray2)}
        {getItem("75th - 60th", theme.palette.gray4)}
      </CarPdfBox>
      <CarPdfBox style={{ flexDirection: "row", gap: 10 }}>
        {getItem("60th - 50th", theme.palette.gray6)}
        {getItem("50th - 40th", theme.palette.softBlack)}
        {getItem("40th - 25th", theme.palette.gray6)}
      </CarPdfBox>
      <CarPdfBox style={{ flexDirection: "row", gap: 10 }}>
        {getItem("25th - 5th", theme.palette.gray4)}
        {getItem("5th - 0", theme.palette.gray2)}
      </CarPdfBox>
    </CarPdfBox>
  );
};
